import { NewCgFormCard } from 'components/IAP/planningView/widgets/NewCgForms/newCgFormBoxes';
import { Ics213RrList } from 'components/IAP/ResourceRequests/ics213rr/Ics213RrList';

/**
 * Many ICS 213RR sheets per incident — the same records as Assets →
 * Resource Requests, listed and created here so Forms and Assets stay in sync.
 */
export function Ics213RrInstanceList() {
  return (
    <NewCgFormCard
      title="Resource Request ICS-213RR"
      formname="ICS_213RR_CG"
      exportLabel="Preview ICS-213RR"
    >
      <Ics213RrList />
    </NewCgFormCard>
  );
}
